<app-page-heading [title]="title"></app-page-heading>

<section class="container-fluid widget-row">

    <div class="widget-container col-sm-6 col-lg-4" *ngIf="loadedHealth">
        <div class="widget widget-full-height text-center">
            <div class="widget-header-colored" [ngClass]="health.status === 'UP' ? 'bg-success' : 'bg-danger'">
                <i class="fa fa-heartbeat"></i>
            </div>
            <div class="widget-body">
                <div class="widget-text">CMBL is {{health.status}}</div>
            </div>
        </div>
    </div>

    <div class="widget-container col-sm-6 col-lg-4" *ngIf="loadedHealth">
        <div class="widget widget-full-height text-center">
            <div class="widget-header-colored" [ngClass]="health.dbStatus === 'UP' ? 'bg-success' : 'bg-danger'">
                <i class="fa fa-database"></i>
            </div>
            <div class="widget-body">
                <div class="widget-text">{{health.dbName}} is {{health.dbStatus}}</div>
            </div>
        </div>
    </div>

    <div class="widget-container col-sm-6 col-lg-4" *ngIf="loadedHealth">
        <div class="widget widget-full-height text-center">
            <div class="widget-header-colored" [ngClass]="health.diskSpaceStatus === 'UP' ? 'bg-success' : 'bg-danger'">
                <i class="fa fa-hdd-o"></i>
            </div>
            <div class="widget-body">
                <div class="widget-text">Disk is {{health.diskSpaceStatus}}</div>
                <div class="widget-text-secondary">{{health.diskSpaceUsed | fileSize}} / {{health.diskSpaceTotal | fileSize}}</div>
                <div class="widget-text-secondary">
                    <div class="progress">
                        <div class="progress-bar" role="progressbar" [ngClass]="health.diskSpacePercent > 80 ? 'bg-danger' : 'bg-success'"
                                [attr.aria-valuenow]="health.diskSpaceUsed" aria-valuemin="0" [attr.aria-valuemax]="health.diskSpaceTotal"
                                [style.width]="health.diskSpacePercent+ '%'"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="widget-container col-sm-6 col-lg-4" *ngIf="loadedMetrics">
        <div class="widget widget-full-height text-center">
            <div class="widget-header-colored" [ngClass]="metrics.memPercent < 80 ? 'bg-success' : 'bg-danger'">
                <i class="fa fa-hdd-o"></i>
            </div>
            <div class="widget-body">
                <div class="widget-text">Memory</div>
                <div class="widget-text-secondary">{{metrics.memUsed | fileSize: 2}} / {{metrics.memTotal | fileSize: 2}}</div>
                <div class="widget-text-secondary">
                    <div class="progress">
                        <div class="progress-bar" role="progressbar" [ngClass]="metrics.memPercent > 80 ? 'bg-danger' : 'bg-success'"
                                [attr.aria-valuenow]="metrics.memUsed" aria-valuemin="0" [attr.aria-valuemax]="metrics.memTotal"
                                [style.width]="metrics.memPercent + '%'"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="widget-container col-sm-6 col-lg-4" *ngIf="loadedMetrics">
        <div class="widget widget-full-height text-center">
            <div class="widget-header-colored bg-primary">
                <i class="fa fa-hdd-o"></i>
            </div>
            <div class="widget-body">
                <div class="widget-text">Uptime</div>
                <div class="widget-text-secondary">{{metrics.uptime | secondsDuration | async}}</div>
            </div>
        </div>
    </div>

</section>


<section class="container-fluid">

    <div class="col-xs-12 col-lg-4" *ngIf="loadedMetrics">
        <div class="ibox float-e-margins">
            <div class="ibox-title">
                <h5>
                    2xx requests
                </h5>
            </div>
            <div class="ibox-content widget-body widget-body-table">
                <div class="widget-body-row" *ngFor="let request of metrics.counter200">
                    <div><span class="badge badge-primary">{{request.code}}</span> {{request.endpoint}}</div>
                    <div>{{request.value}}</div>
                </div>
                <div *ngIf="metrics.counter200.length === 0" class="widget-body-row text-center">
                    <em>No data yet</em>
                </div>
            </div>
        </div>
    </div>

    <div class="col-xs-12 col-lg-4" *ngIf="loadedMetrics">
        <div class="ibox float-e-margins">
            <div class="ibox-title">
                <h5>
                    4xx requests
                </h5>
            </div>
            <div class="ibox-content widget-body widget-body-table">
                <div class="widget-body-row" *ngFor="let request of metrics.counter400">
                    <div><span class="badge badge-danger">{{request.code}}</span> {{request.endpoint}}</div>
                    <div>{{request.value}}</div>
                </div>
                <div *ngIf="metrics.counter400.length === 0" class="widget-body-row text-center">
                    <em>No data yet</em>
                </div>
            </div>
        </div>
    </div>

    <div class="col-xs-12 col-lg-4" *ngIf="loadedMetrics">
        <div class="ibox float-e-margins">
            <div class="ibox-title">
                <h5>
                    5xx requests
                </h5>
            </div>
            <div class="ibox-content widget-body widget-body-table">
                <div class="widget-body-row" *ngFor="let request of metrics.counter500">
                    <div><span class="badge badge-danger">{{request.code}}</span> {{request.endpoint}}</div>
                    <div>{{request.value}}</div>
                </div>
                <div *ngIf="metrics.counter500.length === 0" class="widget-body-row text-center">
                    <em>No data yet</em>
                </div>
            </div>
        </div>
    </div>

</section>
